import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';

const showDevRoutes = process.env.NODE_ENV === 'development';
/* eslint-disable react/jsx-props-no-spreading */
const DevOnlyRoute = React.memo(({
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      showDevRoutes
        ? <Component {...props} />
        : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
    )}
  />
));

DevOnlyRoute.propTypes = {
  match: ReactRouterPropTypes.match,
  history: ReactRouterPropTypes.history,
  location: ReactRouterPropTypes.location,
  authenticated: PropTypes.bool,
  component: PropTypes.elementType,
};


export {
  DevOnlyRoute,
};
